module.exports = __webpack_public_path__ + "img/image_2.c3e8d86e.png";